"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const NewEmailButton_1 = require("./NewEmailButton");
const NewEmailModal_1 = require("./NewEmailModal");
const react_hanger_1 = require("react-hanger");
const react_2 = require("@osmosys/react");
exports.NewEmailView = props => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(exports.NewEmailViewInner, Object.assign({}, props))));
};
exports.NewEmailViewInner = ({ template, templateVersion, showModal = false, modalCanClose = true, asLink = false, children, }) => {
    const { state, setState } = react_hanger_1.useSetState({
        modalCanClose,
        modalIsOpen: showModal,
        name: '',
        template,
        templateVersion,
    });
    react_1.useEffect(() => {
        if (!state.template) {
            setState({
                templateVersion: null,
            });
        }
    }, [!state.template]);
    // Template
    react_1.useEffect(() => {
        if (template) {
            setState({
                template,
            });
        }
    }, [template]);
    // Modal is open
    react_1.useEffect(() => {
        setState({
            modalIsOpen: showModal,
        });
    }, [showModal]);
    // Modal is closed
    react_1.useEffect(() => {
        setState({
            modalCanClose,
        });
    }, [modalCanClose]);
    // Template version
    react_1.useEffect(() => {
        if (templateVersion) {
            setState({
                templateVersion,
            });
        }
    }, [templateVersion]);
    const isDisabled = react_1.useMemo(() => !state.name || !state.templateVersion || !state.template, [state.name, state.template, state.templateVersion]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_2.OsmosysDiv, { className: "flex-row-centered" },
            react_1.default.createElement(NewEmailButton_1.NewEmailButton, { state: state, setState: setState, isDisabled: isDisabled, asLink: asLink }, children)),
        react_1.default.createElement(NewEmailModal_1.NewEmailModal, { state: state, setState: setState, isDisabled: isDisabled, asLink: asLink })));
};
//# sourceMappingURL=index.js.map